export default "__VITE_ASSET__D1S0b0B3__"